import fetchModel from "../../mixin/store/api/fetchModel";
import changeOrPushModel from "@/mixin/store/api/changeOrPushModel";
import fetchModels from "@/mixin/store/api/fetchModels";
import axios from "@/plugins/axios";
import pushModel from "@/mixin/store/api/pushModel";

export default {
    actions: {
        fetchEmployeeAtWork(context) {
            if (context.state.isNeedFetch) {
                return fetchModel(context, 'employee_at_works/about_me', null, 'updateEmployeeAtWork');
            }
        },
        fetchEmployeeAtWorks(context) {
                return fetchModels(context, 'employee_at_works/entries', null, 'updateEmployeeAtWorks');
        },
        putEmployeeAtWork(context, data) {
            return changeOrPushModel(context, 'employee_at_works', data, 'updateEmployeeAtWork')
        },
        searchEmployeeAtWorks(context, searchItem) {
            let url = "employee_at_works?page=" + searchItem.page + '&order[employee.givenName]=desc';

            if (searchItem.employeeGivenName) {
                url = url + '&employee.givenName=' + searchItem.employeeGivenName + '&'
            }

            if (searchItem.employeeFamilyName) {
                url = url + '&employee.familyName=' + searchItem.employeeFamilyName
            }

            if (searchItem.before) {
                url = url + '&createdAt[before]=' + searchItem.before
            }

            if (searchItem.after) {
                url = url + '&createdAt[after]=' + searchItem.after
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)
                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }
                    context.commit('updateEmployeeAtWorks', data)

                })
                .catch((err) => {
                    console.log(err)
                })
        },
        pushEmployeeAtWork(context, data) {
            return pushModel(context, 'employee_at_works', data, 'updateEmployeeAtWork')
        }
    },
    mutations: {
        updateEmployeeAtWork(state, data) {
            state.employeeAtWork = data
            state.employeeAtWork.isNeedFetch = false
        },
        updateEmployeeAtWorks(state, data) {
            state.employeeAtWorks = data
        }
    },
    state: {
        isNeedFetch: true,
        employeeAtWork: {},
        employeeAtWorks: {
            models: [],
            totalItems: 0
        }
    },
    getters: {
        getEmployeeAtWork(state) {
            return state.employeeAtWork
        },
        getEmployeeAtWorks(state) {
            return state.employeeAtWorks.models
        },
        getEmployeeAtWorksTotalCount(state) {
            return state.employeeAtWorks.totalItems
        }
    },
}
